import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toCartesian',
    pure: true,
    standalone: false
})
export class ToCartesianPipe implements PipeTransform {

  transform(value: any, x_labels: string[]): any {
    return value.reduce((accum, tuple: { data: [], label: string }) => {
      tuple.data.forEach((point, x_index) => {
        accum.push({ y: tuple.label, x: x_labels[x_index], value: point })
      })
      return accum;
    }, []);
  }

}
